import { TreeSelect } from 'antd'
import styled from 'styled-components'

export const TreeSelectStyled = styled(TreeSelect)`
  width: 100%;
`
